import { render, staticRenderFns } from "./UpdatePhotoalbumPage.vue?vue&type=template&id=099cc4ee&scoped=true&"
import script from "./UpdatePhotoalbumPage.vue?vue&type=script&lang=js&"
export * from "./UpdatePhotoalbumPage.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePhotoalbumPage.vue?vue&type=style&index=0&id=099cc4ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099cc4ee",
  null
  
)

export default component.exports